import React from 'react';
import { useState, useEffect } from "react";
import { GetServiceCaller, PostServiceCaller } from '../../../../services/serviceCaller';
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants/index"
import MultiAction from '../../../../components/MultiActionCandidate';
import { useLocation } from 'react-router-dom';
import moment from 'moment';



const CandidateinProcess = () => {

  const location = useLocation();
  const dispatch = useDispatch();

  const passedState = location.state;

  useEffect(() => {
    dispatch(updateNavbarHeading(passedState ? passedState?.text : "Candidate In Process"))
  }, [passedState])


  const [formData, setFormData] = useState({
    jobTitle: 0,
    status: 0,
    hrName: 0,
    candidateName: "",
    source: '',
    skill: ''
  })
  const [candidateProcess, setCandidateProcess] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusOpts, setStatusOpts] = useState([]);
  const [jobTitleOpts, setJobTitleOpts] = useState([]);
  const [hrOpts, setHrOpts] = useState([]);
  const [getdataIsClicked, setIsClicked] = useState(false);
  const [apiString, setapiString] = useState("");
  const [sourceOpts, setSourceOpts] = React.useState([]);
  const [skillsOpts, setSkills] = React.useState([]);

  const wrapWithTooltip = (dataArray) => {
    return (dataArray || []).map(item => ({
      ...item,
      RequisitionID: item.RequisitionID ? (
        <span data-job-inactive={item.isJobInactive}>
          {item.RequisitionID}
        </span>
      ) : "",
      RecallRemarks: item.RecallRemarks || "",
    }));
  };

  useEffect(() => {
    if (passedState && passedState.jobTitleFilter) {
      setFormData(prev => ({
        ...prev,
        jobTitle: { value: passedState.jobTitleFilter, label: passedState.text }
      }));
      fetchCandidate(`${API_URL}candidateprocess?CandidateJobDescriptionID=${passedState.jobTitleFilter}&CandidateStatus=0&HRName=0&CandidateName=&source=0&skill=0`);
    } else {
      fetchCandidate();
    }
  }, [passedState]);



  const columns = {
    FullName: { text: "Name", visible: true },
    RequisitionID: { text: "Requisition ID", visible: true },
    JobTitle: { text: "Job Title", visible: true },
    SkillSet: { text: "Skill Set", align: "center", visible: true },
    CandidateReferralType: { text: "Source", visible: true },
    RecruiterName: { text: "TA Name", visible: true },
    ReferralName: { text: "Referred By", visible: true },
    CandidateStatus: { text: "Status", visible: true },
    ExpectedJoiningDate: { text: "Expected Joining", visible: true },
    ActualJoiningDate: { text: "Actual DOJ", visible: true },
    RecallRemarks: { text: "RMG Remarks", visible: false },
  }

  const handleReset = () => {
    setFormData({
      jobTitle: 0,
      status: 0,
      hrName: 0,
      candidateName: "",
      source: '',
      skill: ''
    })
    fetchCandidate()
  }

  const [originalData, setOriginalData] = useState([]);
  // Apply URL filters
  useEffect(() => {
    if (originalData.length === 0) return;

    const queryParams = new URLSearchParams(location.search);
    const candidate = queryParams.get('CandidateStatus')?.trim().toLowerCase();
    const toDate = queryParams.get('JToDate');
    const fromDate = queryParams.get('JFromDate');
    console.log("fromDate toDate", fromDate, toDate);

    const filteredData = originalData.filter(item => {
      const joinDate = moment(item.ActualJoiningDate);
      const fromCondition = fromDate
        ? joinDate.isSameOrAfter(moment(fromDate), 'DD-MMM-YYYY')
        : true;

      const toCondition = toDate
        ? joinDate.isSameOrBefore(moment(toDate), 'DD-MMM-YYYY')
        : true;


      const stat = candidate
        ? item.CandidateStatus?.trim().toLowerCase() === candidate
        : true;
        
      const jobMatch = (passedState && passedState.jobTitleFilter)
        ? Number(item.JobDescriptionID) === Number(passedState.jobTitleFilter) || Number(item.ID) === Number(passedState.jobTitleFilter)
        : true;

      return fromCondition && toCondition && stat && jobMatch;
    });
    console.log("filteredData locally", filteredData);

    setCandidateProcess(wrapWithTooltip(filteredData));
  }, [location.search, originalData, passedState]);

  const [apiStatus, setApiStatus] = useState(undefined)
  const fetchCandidate = async (api_string = `${API_URL}candidateprocess?CandidateJobDescriptionID=0&CandidateStatus=0&HRName=0&CandidateName=&source=0&skill=0`) => {

    setApiStatus(undefined)
    if (getdataIsClicked) {
      try {
        // filter list fetching
        const response = await GetServiceCaller(api_string);
        setApiStatus(response?.status)
        if (response?.status === 200) {
          const apidata = response?.data?.data?.headers;
          setCandidateProcess(wrapWithTooltip(apidata));
          setOriginalData(apidata)
        }
      } catch (error) {
        console.error("Error fetching job:", error);
      }
    } else {
      setApiStatus(undefined)
      try {
        //all list fetching
        const response = await GetServiceCaller(api_string);
        setApiStatus(response?.status)
        if (response?.status == 200) {
          const apidata = response?.data?.data?.headers;
          setCandidateProcess(wrapWithTooltip(apidata));
          setOriginalData(apidata)

          // job title option fetching
          const apidata1 = response?.data?.data?.jobtitle;
          setJobTitleOpts(apidata1);
          // fetch hr
          const apidata2 = response?.data?.data?.hr?.original?.Hr;
          setHrOpts(apidata2);
          // set status
          const apidata3 = response?.data?.data?.status;
          setStatusOpts(apidata3);
          // fetch source
          const apidata4 = response?.data?.data?.source;
          setSourceOpts(apidata4);
          // fetch skills
          const apidata5 = response?.data?.data?.skills;
          setSkills(apidata5);
        }

      } catch (error) {
        console.error("Error fetching job:", error);
      }

    }

  };

  const createEmp = async (candidate_id) => {

    try {
      let formData = { candidate_id: candidate_id }
      const response = await PostServiceCaller(`${API_URL}create-employee`, formData, 'post');
      if (response.data.status == 'success') {
        fetchCandidate();
        return true;
      } else {
        return false;
      }
    } catch (error) {

    }
  }

  const revokeOffer = async (candidate_id) => {
    try {
      const response = await PostServiceCaller(`${API_URL}revoke-offer-letter/${candidate_id}`, {}, 'post');
      if (response && (response.status === 200 || response.data?.status === 200)) {
        fetchCandidate();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error revoking offer:", error);
      return false;
    }
  }



  const statusopts = statusOpts?.map((tech) => ({
    value: tech.value,
    label: tech.text
  }))
  const jobtitleopts = jobTitleOpts?.map((tech) => ({
    value: tech.value,
    label: tech.text

  }))
  const hropts = hrOpts?.map((tech) => ({
    value: tech.value,
    label: tech.text

  }))
  // setting source
  const sourceopts = sourceOpts?.map((row) => ({
    value: row.value,
    label: row.text
  }))
  // setting skills
  const skillsopts = skillsOpts?.map((row) => ({
    value: row.ID,
    label: row.Name
  }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }
  const handleDropDownChange = (selected, name) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: selected,
    }));
  }
  const handleSubmit = async () => {

    // setIsClicked(true);
    setApiStatus(undefined)
    try {
      const arry = formData;
      let apiString2 = `${API_URL}candidateprocess?CandidateJobDescriptionID=${arry.jobTitle?.value || 0}&CandidateStatus=${arry.status?.value || 0}&HRName=${arry.hrName?.value || 0}&CandidateName=${arry.candidateName}&source=${arry.source?.value || 0}&skill=${arry.skill?.value || 0}`;
      setapiString(apiString2);
      const response = await GetServiceCaller(apiString2);
      setApiStatus(response?.status)
      if (response?.status === 200) {
        const apidata = response.data.data.headers;
        setCandidateProcess(apidata);
      }
    } catch (error) {
      console.error("Fetching Get Data  APi Error ", error);

    }


    // alert(JSON.stringify(values));
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          {/* Tabel Section */}
          <div className="row">
            <MultiAction
              createEmp={createEmp}
              data={candidateProcess}
              columns={columns}
              // defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              isApiStatus={apiStatus}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={true}
              showIcon3={true}
              showIcon4={true}

              showIcon5={true}
              formData={formData}
              handleChange={handleChange}
              handleReset={handleReset}
              handleDropDownChange={handleDropDownChange}
              handleSubmit={handleSubmit}
              jobtitleopts={jobtitleopts}
              statusopts={statusopts}
              hropts={hropts}
              sourceopts={sourceopts}
              skillsopts={skillsopts}
              revokeOffer={revokeOffer}
              // handleIcon1={handleEdit}
              // handleIcon2={newapplicationpage}
              //  add more function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon2: <i class="bi bi-clock-history icons"></i>,
                Icon3: <i class="bi bi-envelope-plus icons"></i>,
                Icon4: <i class="bi bi-person-fill icons"></i>,
                Icon5: <i class="bi bi-person-plus icons"></i>
              }}
            />
          </div>

        </div>
      </div>

    </>
  )
}

export default CandidateinProcess;

